<template>
	<div id="body">
		<div class="row">
			<div class="col-12">
				<div class="card mb-2">
					<div class="card-body pb-0">
						<div class="row">
							<div class="col-12 col-lg-2 mb-2">
								<label><i class="far fa-filter font-13 color-theme mr-1 cursor-pointer"></i><span class="font-13">Filtro</span></label>
								<v-select class="rounded" title="Desktop" :options="['Nome','Email',]" v-model="pesquisa.tipo"/>
								<select title="Mobile" class="form-control rounded" v-model="pesquisa.tipo">
									<option v-for="(option, index) in ['Nome','Email',]" :key="index" :value="option">{{ option }}</option>
								</select>
							</div>
							<div class="col-10 col-lg-7 mb-3">
								<label><i class="far fa-search font-13 color-theme mr-1 cursor-pointer"></i><span class="font-13">Procurar</span></label>
								<input title="Mobile" class="form-control rounded" type="text" placeholder="Digite aqui" v-model="pesquisa.valor"/>
								<input title="Desktop" class="form-control rounded" type="text" placeholder="Digite aqui" v-model="pesquisa.valor"/>
							</div>
							<div class="col-2 col-lg-1 align-self-end mb-3">
								<button class="btn btn-secondary w-100 rounded" @click="getUser()">
									<i class="fa fa-search font-13"></i>
								</button>
							</div>
							<div class="col-12 col-lg-2 align-self-end mb-3">
								<button class="btn btn-secondary w-100 rounded" @click="addUser()">
									<i class="fa fa-plus font-13 mr-1"></i> Adicionar
								</button>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-center mb-1 font-italic font-14">
						<span v-if="user.length == 1">{{user.length + ' resultado encontrado'}}</span>
						<span v-else-if="user.length > 1">{{user.length + ' resultados encontrados'}}</span>
					</div>
				</div>
				<div v-if="user.length > 0">
					<div class="cards">
						<div v-for="(u, index) in user" :key="index" :index="index" >
							<div>
								<div class="card d-flex p-3 font-16 mb-0 mt-0">
									<div class="justify-content-center">
										<div>
											<span class="unicoLimitador">
												<i class="fas fa-user mr-1 font-14 color-theme"></i><span class="font-16 font-weight-bold">{{u.nomeCompleto}}</span>
											</span>
										</div>
										<div>
											<span class="unicoLimitador">
												<i class="fas fa-at mr-1 font-14 color-theme"></i><span>{{u.email}}</span>
											</span>
										</div>
									</div>
									<div class="mt-3 d-flex justify-content-center">
										<div class="mr-0">
											<button type="button" class="btn btnLogins-edit rounded " @click="editar(u)"><span class="font-13">Editar</span></button>
										</div>
										<div class="ml-1">
											<button type="button" class="btn btnLogins-edit rounded" @click="transferir(u)"><span class="font-13">Transferir</span></button>
										</div>
										<div class="ml-1">
											<button type="button" class="btn btnLogins-danger rounded" @click="excluir(u.id, index)"><span class="font-13">Excluir</span></button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-body mb-3 text-center font-16" v-else>Nenhum login encontrado</div>
			</div>

			<!-- modal editar -->
			<div class="modal fade" id="modalEditar" tabindex="-1" aria-labelledby="modalEditarLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true">
				<div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title h4 color-theme" v-if="userEditar.id != null"><span class="font-17">Editar login</span></h5>
							<h5 class="modal-title h4 color-theme" v-else><span class="font-17">Adicionar login</span></h5>
							<button type="button" class="close text-danger" data-dismiss="modal" aria-label="Close" @click="limparInputs()"><span aria-hidden="true">×</span></button>
						</div>
						<div class="modal-body mb-0" >
							<div class="row" v-if="travaContinuar == false">
								<div class="col-12 mb-3">
									<label><i class="fas fa-user font-13 color-theme mr-1"></i><span class="font-14"> Nome completo: </span></label>
									<input type="text" class="form-control rounded" maxlength="200"  placeholder="Nome do usuário" v-model="userEditar.nomeCompleto"/>  
								</div>
								<div class="col-12 mb-3">
									<label><i class="fas fa-envelope font-13 color-theme mr-1"></i><span class="font-14"> Email: </span></label>
									<input type="email" class="form-control  rounded" maxlength="200"  placeholder="Nome do usuário" v-model="userEditar.email"/>  
								</div>
								<div class="col-12 mb-3 password-input">
									<label><i class="fas fa-key font-13 color-theme mr-1"></i><span class="font-14"> Senha: </span></label>
									<input class="form-control rounded password-field" maxlength="200" :type="showPassword ? 'text' : 'password'" placeholder="Nome da escola" v-model="userEditar.senha"/>  
									<span @click="toggleShowPassword" class="toggle-password">
										<i v-if="showPassword" class="fas fa-eye"></i>
										<i v-else class="fas fa-eye-slash"></i>
									</span>
								</div>
								<div class="col-12 mb-3">
									<div class="d-flex justify-content-between ">
										<span class="font-14"> Esse usuario terá acesso admin: </span>
										<label class="container_marker">
											<input type="checkbox" v-model="userEditar.admin">
											<div class="checkmark"></div>
										</label>
									</div>
								</div>
							</div>

							<div class="col-12" v-if="travaContinuar == true">
								<div class="cards mb-0">
									<div v-for="(escola, index) in userEditar.listaEscola" :key="index">
										<div class="card mb-0">
											<div class="d-flex justify-content-between">
												<div class=" cursor-pointer p-3 font-16 align-self-center">
													<span class="limitador font-16 font-weight-bold">{{escola.nome}}</span>
													<span class="limitador font-italic">{{escola.endereco}}</span>
												</div>
												<div class="mr-4 align-self-center">
													<label class="container_marker">
														<input type="checkbox" v-model="escola.addEscola">
														<div class="checkmark"></div>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer mb-0">
							<div v-show="travaContinuar == false">
								<button type="button" class="btn rounded btnFechar" data-dismiss="modal" @click="limparInputs()">Cancelar</button>
							</div>
							<div v-if="travaContinuar == false">
								<button type="button" class="btn btn-secondary rounded" @click="alterarBtn()">Continuar</button>
							</div>
							<div v-if="travaContinuar == true">
								<button type="button" class="btn rounded btnFechar" @click="alterarBtn()">Voltar</button>
							</div>
							<div v-if="travaContinuar == true">
								<button type="button" class="btn btn-secondary rounded" @click="salvar()">Salvar</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- modal transferir -->
			<div class="modal fade" id="modalTransferir" tabindex="-1" aria-labelledby="modalTransferirLabel" data-backdrop="static" data-keyboard="false" aria-hidden="true">
				<div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
					<div class="modal-content h-75">
						<div class="modal-header">
							<h5 class="modal-title h4 color-theme"><span class="font-17">Transferir</span></h5>
							<button type="button" class="close text-danger" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
						</div>
						<div class="modal-body mb-0" >
							<div class="row" v-if="travaContinuar == false">
								<div class="col-12">
									<div class="card">
										<div class="card-body">
											<span>Selecione um usuário para transferir todos os cadastros de uma escola do <span class="color-theme">{{ userTransfer.nomeCompleto }}</span> para o usuário selecionado a baixo.</span>
										</div>
									</div>
									<div class="card">
										<div class="card-body">
											<div class="col-12 mb-2">
												<label><i class="fas fa-user font-13 color-theme mr-1"></i><span class="font-14"> Selecione o capelão: </span></label>
												<v-select title="Desktop" :options="capeloes" v-model="transferenciaCapelao" label="capelaoNome" class="rounded"/>
												<select title="Mobile" class="form-control text-danger" v-model="transferenciaCapelao"> 
													<option v-for="(option, index) in capeloes" :key="index" :value="option">{{ option.capelaoNome }}</option>
												</select>
											</div>
										</div>
									</div>
									<div class="card mb-2">
										<div class="card-body">
											<label><i class="fas fa-home font-13 color-theme mr-1"></i><span class="font-14"> Selecione a escola: </span></label>
											<v-select title="Desktop" :options="listaEscola" v-model="transferenciaDestino" label="nome" class="rounded"/>
											<select title="Mobile" class="form-control text-danger" v-model="transferenciaDestino"> 
												<option v-for="(option, index) in listaEscola" :key="index" :value="option">{{ option.nome }}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer mb-0">
							<div>
								<button type="button" class="btn rounded btnFechar" data-dismiss="modal">Cancelar</button>
							</div>
							<div>
								<button type="button" class="btn btn-secondary rounded" @click="salvarTransferencia()">Salvar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
	name: 'Logins',
	computed: {
		... mapState({
			dadosUsuario: state => state.dadosUsuario,
			isCarregando: state => state.isCarregando,
			isLogado: state => state.isLogado,
			urlRest: state => state.urlRest
		})
	},
	data() {
        return {
			showPassword: false,
			travaContinuar: false,
			user: {
				nomeCompleto: '',
				email: '',
				senha: '',
				admin: false,
				id: null,
			},
			userEditar: {},
			pesquisa: {
				tipo: 'nome',
				valor: ''
			},
			userTransfer: {},
			transferenciaCapelao: {},
			capeloes: [],
			listaEscola: [],
			transferenciaDestino: {}
      };
   },
	methods: {
		salvar() {
			let ref = this;

			if(this.userEditar.nomeCompleto == null || this.userEditar.nomeCompleto == '') {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha o nome do login' 
				})

				return
			} else if(this.userEditar.email == null || this.userEditar.email == '') {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha o email do login' 
				})

				return
			} else if(this.userEditar.senha == null || this.userEditar.senha == '') {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha a senha do login' 
				})

				return
			}

			this.$store.dispatch('alternarTelaCarregamento', true);
			this.$axios({
				method: 'post',
				url: this.urlRest +'service/addUser',
				headers: {
					'Content-Type': 'application/json'
				},

				data: this.userEditar
			}).then(function () {
				ref.$toast.fire({
					icon: 'success',
					title: 'Usuário salvo!',
					timer: 1500
				})
				$('#modalEditar').modal('hide')
				ref.limparInputs()
				ref.getUser()
			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						})
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					})
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false);
			});
			this.user 
		},
		limparInputs() {
			this.userEditar.nomeCompleto = null
			this.userEditar.senha = null
			this.userEditar.email = null
			this.userEditar.admin = false
			this.userEditar.id = null
			this.travaContinuar = false
		},
		getEscola() {
			let ref = this;
			this.$axios({
				method: 'get',
				url: this.urlRest +'service/getEscola',
				params: {
					id: this.userEditar.id
				}
			}).then(response => {
			ref.userEditar.listaEscola = response.data;
			ref.listaEscola = response.data;

			}).catch(function (error) {
			if (error.response != undefined) {
				if (error.response.status == 408) {
					ref.$store.dispatch('deslogar')

					ref.$toast.fire({
						icon: 'warning',
						title: 'Sessão expirada!'
					});
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: 'Erro: ' + error.response.status
					})
				}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					})
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false);
			});
		},
		getUser() {
			let ref = this;
				this.$store.dispatch('alternarTelaCarregamento', true)

				this.$axios({
					method: 'get',
				url: this.urlRest + 'service/getUser',
				params: {
					tipo: this.pesquisa.tipo,
					valor: this.pesquisa.valor,
				}

			}).then(response => {
				ref.user = response.data;

			}).catch(function (error) {
				if (error.response != undefined) {
				if (error.response.status == 408) {
					ref.$store.dispatch('deslogar')

					ref.$toast.fire({
						icon: 'warning',
						title: 'Sessão expirada!'
					});
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: 'Erro: ' + error.response.status
					});
				}
				} else {
				ref.$toast.fire({
					icon: 'error',
					title: error
				});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},
		addUser() {
			this.limparInputs()
			this.getEscola()
			
			$('#modalEditar').modal('show')
		},
		toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
		excluir(id, index) {
			let ref = this;

			Swal.fire({
			icon: 'warning',
			title: 'Deseja excluir esse login?',
			confirmButtonText: 'Confirmar',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'

			}).then((result) => {
				if (result.isConfirmed) {

					this.$axios({
						method: 'post',
						url: this.urlRest + 'service/deleteuser',
						params: {
							id: id,
						}
					}).then(() => {
						ref.user.splice(index,1)
					})
					
				}
			}).catch(function (error) {
				if (error.response != undefined) {
				if (error.response.status == 408) {
					ref.$store.dispatch('deslogar')

					ref.$toast.fire({
						icon: 'warning',
						title: 'Sessão expirada!'
					});
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: 'Erro: ' + error.response.status
					});
				}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			})
		},
		editar(u) {
			this.userEditar = JSON.parse(JSON.stringify(u))
			$('#modalEditar').modal('show')

			this.getEscola()
		},
		alterarBtn() {
			this.travaContinuar = !this.travaContinuar
			console.log(this.travaContinuar)
		},
		getCapelao: function () {
			let ref = this;
			this.capeloes = []

			this.$store.dispatch('alternarTelaCarregamento', true)
			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getCapelao'

			}).then(response => {
				ref.capeloes = response.data;

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
		},
		transferir(u) {
			this.userTransfer = u
			this.getCapelao()
			this.getEscola()
			$('#modalTransferir').modal('show')
		},
		salvarTransferencia() {
			let ref = this;

			if (this.userTransfer.id == this.transferenciaCapelao.capelaoId) {
				ref.$toast.fire({
					icon: 'warning',
					title: 'Você não pode transferir para o mesmo usuário'
				});
				return
			}

			if (this.transferenciaDestino.id == 0) {
				ref.$toast.fire({
					icon: 'warning',
					title: 'Você não pode transferir para o Admin'
				});
				return
			}

			Swal.fire({
				icon: 'warning',
				title: 'Tem certeza que deseja transferir todos os cadastros para ' + this.transferenciaCapelao.nomeCompleto + '?',
				confirmButtonText: 'Confirmar',
				showCancelButton: true,
				cancelButtonText: 'Cancelar'

			}).then((result) => {
				if (result.isConfirmed) {
					this.$store.dispatch('alternarTelaCarregamento', true)
					this.$axios({
						method: 'post',
						url: this.urlRest + 'service/transfereAllAlunos',
						params: {
							capelaoIdRecebe: this.transferenciaCapelao.capelaoId,
							capelaoIdTransfere: this.userTransfer.id,
							capelaoNome: this.transferenciaCapelao.capelaoNome,
							idEscola: this.transferenciaDestino.id,
							nomeEscola: this.transferenciaDestino.nome
						}
					}).then(response => {
						ref.capeloes = response.data;
						$('#modalTransferir').modal('hide')
						
					}).catch(function (error) {
						if (error.response != undefined) {
							if (error.response.status == 408) {
								ref.$store.dispatch('deslogar')

								ref.$toast.fire({
									icon: 'warning',
									title: 'Sessão expirada!'
								});
							} else if (error.response.status == 400) {
								ref.$toast.fire({
									icon: 'warning',
									title: 'O aluno não pode ser transferido para um capelão que não tem acesso a esta escola'
								});
							} else {
								ref.$toast.fire({
									icon: 'error',
									title: 'Erro: ' + error.response.status
								});
							}
						} else {
							ref.$toast.fire({
								icon: 'error',
								title: error
							});
						}
					}).finally(() => {
						this.$store.dispatch('alternarTelaCarregamento', false)
					});
					ref.$toast.fire({
						icon: 'success',
						title: 'Transferido!',
						timer: 1500,
					});

					$('#modalPerfil').modal('hide')

					this.modalConfig.transferencia = false;
					this.modalConfig.transferenciaDestino = null;
					this.modalConfig.transferenciaCapelao = null;
					this.pesquisarUsuario(0)
				}
			})
		},
	},
	mounted(){
		this.getUser()	
	}
}

</script>

<style scoped>
.container_marker input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.card {
	margin-bottom: 5px;
}

.btnFechar {
	color: white;
	background-color: #616161;
}

.container_marker {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  border-radius: 50%;
  background-color: rgb(78, 78, 78);
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1em;
  width: 1em;
  transition: .3s;
  transform: scale(0);
  border-radius: 50%;
}

/* When the checkbox is checked, add a blue background */
.container_marker input:checked ~ .checkmark {
  background-color: #2096c5;
  transform: scale(1);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_marker input:checked ~ .checkmark:after {
  display: block;
}

.container_marker input:checked ~ .celebrate {
  display: block;
}

/* Style the checkmark/indicator */
.container_marker .checkmark:after {
  left: 7px;
  top: 0.25em;
  width: 0.30em;
  height: 0.5em;
  border: solid rgb(255, 255, 255);
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.container_marker .celebrate {
  position: absolute;
  transform-origin: center;
  animation: kfr-celebrate .4s;
  animation-fill-mode: forwards;
  display: none;
  stroke: #0392CF;
}

@keyframes kfr-celebrate {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
    display: none;
  }

}

.aluno_card {
   padding: 10px;
   border-left: 5px solid #555;
}

.aluno_card_image {
   width: 65px;
   float: left;
}

.aluno_card_corpo {
   margin-left: 75px;
}

.aluno_botao {
   right: 10px;
   top: 10px;
   position: absolute;
}

.aluno_botao button {
   margin: 3px;
   height: 60px;
   width: 60px;
}

.aluno_card_image img {
   width: 100%;
}


.switch input[type="checkbox"]:not(:checked)+.slider {
   background-color: #3c3e42
}

input[type="date"]::-webkit-calendar-picker-indicator {
   filter: invert(50%);
}

.slide-up-enter-active {
   transition: all 0.4s;
}

.slide-up-enter {
   transform: translateY(-100%);
   opacity: 0;
}

.slide-up-leave-to {
   transform: translateY(-100%);
   opacity: 0;
}

.custom-hover-class {
   background-color: red;
   color: white;
}

.btnLogins-edit {
	font-weight: bold;
	color: #bebebe;
	border: solid 1px #bebebe;
}

.btnLogins-edit:hover {
	background: #dfdfdf;
	color: #222427;
	font-weight: bold;
}

.btnLogins-danger {
	font-weight: bold;
	color: #bebebe;
	border: solid 1px #bebebe;
}

.btnLogins-danger:hover {
	border: solid 1px #fd4343;
	background: #fd4343;
	color: #222427;
	font-weight: bold;
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}
</style>